import React, { Component } from 'react';

import AllTeamScores from './allteams/AllTeamScores';
import Fantasy from './allteams/Fantasy';
import HomeAway from './allteams/HomeAway';

class AllTeams extends Component {
  constructor(props) {
      super(props);
      this.state = {
        curPage: 3,
        yearFilter: 2024,
        years: [{"yr": 2024},{"yr": 2023},{"yr": 2022},{"yr": 2021},{"yr": 2020},{"yr": 2019},{"yr": 2018}, {"yr": 2017}, {"yr": 2016}, {"yr": 2015}, {"yr": 2014}, {"yr": 2013}, {"yr": 2012}]
      };
      this.handlePageChange = this.handlePageChange.bind(this);
      this.handleYearChange = this.handleYearChange.bind(this);
  }
  handlePageChange(event) {
    let num;
    if(event.currentTarget.id === "allteamscores"){
      num = 1;
    } else if (event.currentTarget.id === "fantasy"){
      num = 2;
    } else if (event.currentTarget.id === "homeaway"){
      num = 3;
    }
    this.setState({
      curPage : num
    });
  }
  getCurPage() {
    if(this.state.curPage === 1){
      return <AllTeamScores yearFilter={this.state.yearFilter}/>;
    } else if (this.state.curPage === 2) {
      return <Fantasy  yearFilter={this.state.yearFilter}/>;
    } else if (this.state.curPage === 3) {
      return <HomeAway yearFilter={this.state.yearFilter}/>;
    }
  }
  handleYearChange(event) {
    this.setState({
      yearFilter : Number(event.currentTarget.value)
    });
  }
  getYearSelect() {
    const years = this.state.years.map((year) =>
        <option key={year.yr} value={year.yr}>{year.yr}</option>
    );
    return <span className="medium-2 columns"><select id="year_filter" value={this.state.yearFilter} onChange={this.handleYearChange}>
      {years}
      </select></span>;
  }
  render() {
    return (
      <div>
        <div className="row expanded">
          <div className="small-12 columns">
            <div className="button-container">
              <button id="homeaway" className={"button medium" + (this.state.curPage === 3 ? '' : ' secondary')} onClick={this.handlePageChange}>Home/Away Diff</button>
              <button id="allteamscores" className={"button medium" + (this.state.curPage === 1 ? '' : ' secondary')} onClick={this.handlePageChange}>All Team Scores</button>
              <button id="fantasy" className={"button medium" + (this.state.curPage === 2 ? '' : ' secondary')} onClick={this.handlePageChange}>All Avg/High</button>
            </div>
          </div>
        </div>
        <div className="row expanded">
          <div className="small-12 columns">
            {this.getYearSelect()}
          </div>
        </div>
        <div className="row expanded">
          <div className="small-12 columns">
            {this.getCurPage()}
          </div>
        </div>
      </div>
    );
  }
}

export default AllTeams;



// WEBPACK FOOTER //
// ./src/components/AllTeams.js